export default __webpack_public_path__ + "static/media/csharp.cef8e3f1.png";